import React from "react";
import {
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useSelector } from "react-redux";
import { variables } from "../../../variables/variables";
import "./LocationsSection.scss";
import LocationItem from "../LocationItem/LocationItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const LocationsSection = ({
  header,
  copy,
  children,
  subheader = "subhead",
  locations = [],
}) => {
  const isMobile = useSelector(
    (state) => state.layout.displayWidth < variables.breakpoints.lrg
  );

  return (
    <Box className="location-section" component="section">
      <h3 className="location-section__header">{header}</h3>
      <Grid container>
        <Grid item xs={12} md={12} lg={3}>
          <p className="location-section__copy">{copy}</p>
        </Grid>
        <Grid item xs={12} md={12} lg={9}>
          <Box pl={{ md: 0, lg: 8 }}>
            {!children ? (
              !isMobile ? (
                <ul className="location-section__list">
                  {locations.map((location) => {
                    return (
                      <LocationItem
                        key={location.name}
                        locationName={location.name}
                        locationAddress={location.address}
                        stockDays={location.stockDays}
                        locationLinkUrl={location.locationUrl}
                      />
                    );
                  })}
                </ul>
              ) : (
                <Accordion disableGutters elevation={0}>
                  <AccordionSummary
                    sx={{ px: 0, py: 1 }}
                    expandIcon={<KeyboardArrowDownIcon />}
                    aria-controls={`${subheader}-panel`}
                    id={`${subheader}-header`}
                  >
                    <p className="location-section__accordion-title">
                      {subheader}
                      <span className="location-section__accordion-badge">
                        {locations.length}
                      </span>
                    </p>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ul className="location-section__list">
                      {locations.map((location) => {
                        return (
                          <LocationItem
                            key={location.name}
                            locationName={location.name}
                            locationAddress={location.address}
                            stockDays={location.stockDays}
                            locationLinkUrl={location.locationUrl}
                          />
                        );
                      })}
                    </ul>
                  </AccordionDetails>
                </Accordion>
              )
            ) : (
              children
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LocationsSection;
